import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = () => {
    const { isAuthenticated } = useSelector(
        (state) => state.auth
    );

    const token = localStorage.getItem(
        "access_token"
    );

    if (!isAuthenticated || !token) {

        return (
            <Navigate
                to="/"
                replace
            />
        );
    }

    return <Outlet />;
};

export default ProtectedRoute;